<template>
  <div>
    <span>Реферальный коэффицент для обычных пользователей:</span>
    <v-text-field
      v-model="regular.default_percent"
      :rules="[mediaRules]"
      type="number"
      color="accent"
      class="field"
    />
    <br>
    <span>Реферальный коэффицент для медиа пользователей:</span>
    <v-text-field
      v-model="media.default_percent"
      :rules="[regularRules]"
      type="number"
      color="accent"
      class="field"
    />
    <br>
    <span>Количество депозитов: {{ count_deps }}</span>
    <br><br>
    <span>Сумма депозитов: {{ sum_deps }}</span>
    <Base--SideButtons :save="validate" />
  </div>
</template>

<script>
import { getReferralCatgories, updateReferralCategory } from '../../api/user'

export default {
  data () {
    return {
      count_deps: 0,
      sum_deps: 0,
      media: {
        default_percent: 0
      },
      regular: {
        default_percent: 0
      }
    }
  },
  created () {
    getReferralCatgories(1).then(res => {
      this.count_deps = res.data.count_deps
      this.sum_deps = res.data.sum_deps
      res.data.categories.forEach(item => {
        if (item.name === 'media') {
          this.media = item
          this.media.default_percent *= 100
        } else if (item.name === 'regular') {
          this.regular = item
          this.regular.default_percent *= 100
        }
      })
    })
  },
  methods: {
    regularRules (value) {
      if (value < 2)
        return '< 2'
      if (value > 10)
        return '> 10'

      return true
    },
    mediaRules (value) {
      if (value < 2)
        return '< 2'
      if (value > 10)
        return '> 10'

      return true
    },
    validate () {
      if (this.media.default_percent >= 2 && this.media.default_percent <= 10
                    && this.regular.default_percent >= 2 && this.regular.default_percent <= 10)
        this.f()

    },
    f () {
      this.AxiosHelperShowResponce(updateReferralCategory(this.media.id, {
        name: this.media.name,
        default_percent: this.media.default_percent / 100
      }))
      this.AxiosHelperShowResponce(updateReferralCategory(this.regular.id, {
        name: this.regular.name,
        default_percent: this.regular.default_percent / 100
      }))
    }
  }
}
</script>
